import { Plugins } from '@capacitor/core'
const { App } = Plugins

export default async ({router}) => {
	App.addListener('appUrlOpen', (data) =>{
		const url = new URL(data.url)

		if (url.pathname !== '/' || url.search !== '') {
			router.push({
				path: `${url.pathname === '/' ? '/home': url.pathname}${url.search}`
			})
		}
	})
}
